import { FC } from 'react';
import { TwoFaSectionTitle } from '../../shared/TwoFaSectionTitle';
import { css } from '@bts-web/utils-style-engine';
import { ButtonBase } from '../../../../ButtonBase/ButtonBase';
import { TwoFaSectionDescription } from '../../shared/TwoFaSectionDescription';
import { TwoFaSectionButtonsWrapper } from '../../shared/TwoFaSectionButtonsWrapper';
import { TTwoFaCommonProps } from '../types';
import { TwoFaContentWrap } from '../../shared/TwoFaContentWrap';
import { TwoFaScreenTranslations } from '../../ResetTwoFaModal/utils/get2faTranslations';

const InitialPage: FC<
  Pick<TTwoFaCommonProps, 'onDismiss' | 'onContinue' | 'dismissLoading'> & {
    translations: TwoFaScreenTranslations;
  }
> = ({ onContinue, onDismiss, dismissLoading, translations }) => {
  return (
    <>
      <TwoFaContentWrap>
        <TwoFaSectionTitle title={translations.welcome2faSubtitle} />
        <TwoFaSectionDescription textContent={translations.welcome2faBody} />
      </TwoFaContentWrap>
      <TwoFaSectionButtonsWrapper>
        <ButtonBase
          isLoading={dismissLoading}
          onClick={onContinue}
          visual="primary"
          size="large"
          fullWidth
          disabled={dismissLoading}
        >
          {translations.continue}
        </ButtonBase>
        <ButtonBase
          disabled={dismissLoading}
          isLoading={dismissLoading}
          visual="ghost"
          onClick={onDismiss}
          className={css({
            textDecoration: 'underline',
          })}
        >
          {translations.welcome2faCtaSkip}
        </ButtonBase>
      </TwoFaSectionButtonsWrapper>
    </>
  );
};

export { InitialPage };
